import React, { useEffect, useState } from "react";
import { API } from "../../config/api.js";

import "bulma/css/bulma.css";
import "../../index.css"
import { Button, Col, Form, Row } from "react-bootstrap";
import { useMediaQuery } from 'react-responsive'
import { useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";
import LoaderHome from "../Loader/LoaderHome.js"

import FilterCard from "../Admin/Components/Filter.js";

import TableAppointmentDoctor from "./Components/TableAppointmentDoctor.js";
import HeaderApointmentDoctor from "./Components/HeaderAppointmentDoctor.js";
import WellcomeCard from "../Admin/Components/Filter.js";
import SelectInputField from "../Global/SelectInputField.js";
import ModalDetailPatient from "./ModalDoctorDetail/ModalPatientDetail.js"




export default function Login() {
    document.title = "SDC Apps";

    const navigate = useNavigate()

    const token = localStorage.getItem("token");
    const level = localStorage.getItem('level');
    const rolesData = JSON.parse(localStorage.getItem('roles')) || [];
    const filteredRoles = rolesData.filter(role => role.name === 'Doctor');
    const filteredRolesAdmin = rolesData.filter(role => role.name === 'Admin');
    const filteredRolesANurse = rolesData.filter(role => role.name === 'Nurse');
    const levelUser = localStorage.getItem('level');


    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const currentYear = new Date().getFullYear();
    const [selectedYear, setSelectedYear] = useState(currentYear.toString());
    const [pages, setPages] = useState();
    const [msg, setMsg] = useState("");
    const [rows, setRows] = useState(1);
    const [ascending] = useState(0);
    const [keyword, setKeyword] = useState("");
    const [query, setQuery] = useState("");

    const [loading, setLoading] = useState(false);

    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 980px)' })



    const [getDataProfileDetail, setGetDataProfileDetail] = useState([]);
    const [getData, setGetData] = useState([]);
    const [getDataDoctorName, setGetDataDoctorName] = useState([]);
    const [countAppointment, setCountAppointment] = useState(0);
    const [modalDetaiDataPatient, setModalDetailPatient] = useState(false);
    const [getDetailDataPatient, setGetDetailDataPatient] = useState([]);
    const [idDetailPatient, setIdDetailPatient] = useState();



    const { id_doctor } = useParams()
    let fetchParams = {
        headers: { "Authorization": `${token}`, "Content-Type": "application/json" }
    };



    const GetResponseDataProfile = async () => {
        try {
            setLoading(true);
            const response = await API.get(`user-service/auth/profile`, fetchParams);
            if (response?.status === 200) {
                setGetDataProfileDetail(response.data.data.user_detail);
            } else {
                throw new Error('Profile data failed');
            }
        } catch (error) {
            swal({
                title: 'Failed',
                text: `${error.response?.data?.message || error.message}`,
                icon: 'error',
                timer: 3000,
                buttons: false,
            });
        }
    };

    const GetResponseData = async () => {
        try {
            const monthParam = selectedMonth ? `&month=${selectedMonth}` : "";
            const yearParam = selectedYear ? `&year=${selectedYear}` : "";
            const response = await API.get(
                `transaction-service/appointments/doctor/${id_doctor}?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}${monthParam}${yearParam}`,
                fetchParams
            );

            if (response?.status === 200) {
                const data = response.data.data || [];
                setGetData(data);
                setCountAppointment(response.data.countAppointment || 0);
                if (data.length > 0) {
                    setGetDataDoctorName(data[0]?.doctor_name);
                }
                setPage(response.data.pagination.current_page);
                setPages(response.data.pagination.total_pages);
                setRows(response.data.pagination.total);
            } else {
                throw new Error('Appointments data failed');
            }
        } catch (error) {

            const message = error?.response?.data?.message || error.message;

            if (message === "Appointment not found") {
                setGetData([]);
                setCountAppointment(0);
                setGetDataDoctorName("");
            }

            if (error.response.status === 401) {
                navigate('/dashboard')
                swal({
                    title: 'Failed',
                    text: `Akses dibatasi Tidak Dapat Mengakses Halaman Ini`,
                    icon: 'error',
                    timer: 3000,
                    buttons: false
                });
            }
        }
    };

    const GetResponseDetailPatient = async () => {
        try {
            // e.preventDefault();
            setLoading(true)
            const response = await API.get(`transaction-service/patients/${idDetailPatient}`, fetchParams)
            // Checking process
            if (response?.status === 200) {
                setGetDetailDataPatient(response?.data?.data)
            }
        } catch (error) {
            swal({
                title: 'Failed',
                text: `${error.response.data.message}`,
                icon: 'error',
                timer: 3000,
                buttons: false
            });
        }
    }

    const GetAllData = async () => {
        try {
            setLoading(true);
            await Promise.all([GetResponseDataProfile(), GetResponseData()]);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleReset = () => {
        setSelectedMonth("");
        setSelectedYear(currentYear.toString());
        GetResponseData();

        setLoading(false);
    };

    useEffect(() => {
        if (limit !== 10) {
            setPage(1);
        }

        GetAllData();

    }, [page, limit, keyword, selectedMonth, selectedYear]);


    useEffect(() => {
        const fetchDetail = async () => {
            setLoading(true);
            await GetResponseDetailPatient();
            setLoading(false);
        };

        if (modalDetaiDataPatient && idDetailPatient) {
            fetchDetail();
        }
    }, [modalDetaiDataPatient, idDetailPatient]);

    const changePage = ({ selected }) => {
        setPage(selected + 1);
        if (selected === 10) {
            setMsg(
                ""
            );
        } else {
            setMsg("");
        }
    };

    const searchData = (e) => {
        e.preventDefault();
        setPage(0);
        setMsg("");
        setKeyword(query);
    };

    const buttonRefresh = () => {
        window.location.reload();
    };

    function formatToRupiah(angka) {
        const formatter = new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
            minimumFractionDigits: 0,
        });

        // Format angka ke format mata uang Rupiah
        const formattedString = formatter.format(angka);

        // Menghilangkan simbol "RP" (simbol mata uang) dari hasil format
        const rupiahWithoutSymbol = formattedString.replace('Rp', '');

        return rupiahWithoutSymbol.trim(); // Menghilangkan spasi yang mungkin ada
    }

    const monthList = [
        { label: "Pilih Bulan", value: "" },
        ...Array.from({ length: 12 }, (_, i) => {
            const month = (i + 1).toString().padStart(2, "0");
            const monthName = [
                "Januari", "Februari", "Maret", "April", "Mei", "Juni",
                "Juli", "Agustus", "September", "Oktober", "November", "Desember"
            ][i];
            return { label: monthName, value: month };
        })
    ];


    const yearList = Array.from({ length: 6 }, (_, i) => {
        const year = 2020 + i;
        return { label: year.toString(), value: year.toString() };
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "month") setSelectedMonth(value);
        if (name === "year") setSelectedYear(value);
    };

    const modalDetailPatient = (id) => {
        setIdDetailPatient(id);
        setModalDetailPatient(true);
    };


    return (
        <>
            <FilterCard>
                <Row className="w-100 m-0 d-flex justify-content-center align-items-center">
                    <Col md={4}>
                        <WellcomeCard>
                            <div className="d-flex flex-column align-items-center">
                                <span style={{ fontWeight: "bold", fontSize: "16px" }}>Total Pendapatan</span>
                                <span style={{ fontSize: "20px", color: "#001F8B" }}>
                                    Rp. {formatToRupiah(getData[0]?.total_price) ?? 0}
                                </span>
                            </div>
                        </WellcomeCard>
                    </Col>
                    <Col md={7}>
                        <WellcomeCard>
                            <Row className="d-flex justify-content-center">
                                <Col md={6}>
                                    <SelectInputField
                                        label="Tahun"
                                        name="year"
                                        value={selectedYear}
                                        onChange={handleChange}
                                        options={yearList}
                                    />
                                </Col>
                                <Col md={6}>
                                    <SelectInputField
                                        label="Bulan"
                                        name="month"
                                        value={selectedMonth}
                                        onChange={handleChange}
                                        options={monthList}
                                        disabled={!selectedYear}
                                    />
                                </Col>
                            </Row>
                        </WellcomeCard>
                    </Col>
                </Row>
            </FilterCard>
            <div style={{ backgroundColor: "white", marginTop: "15px", marginLeft: "10px", marginRight: "10px", boxShadow: "2px 2px 10px #BFBFBF" }}>
                {modalDetaiDataPatient && <ModalDetailPatient GetResponseData={GetResponseDetailPatient} getDetailDataPatient={getDetailDataPatient} idDetailPatient={idDetailPatient} show={modalDetaiDataPatient} onHide={() => setModalDetailPatient(false)} />}

                {loading && <LoaderHome />}
                {isTabletOrMobile ?
                    <>
                        {/* start header */}
                        <HeaderApointmentDoctor
                            isTabletOrMobile={isTabletOrMobile}
                            query={query}
                            countAppointment={countAppointment}
                            handleReset={handleReset}
                            setQuery={setQuery}
                            limit={limit}
                            setLimit={setLimit}
                            setPage={setPage}
                            buttonRefresh={buttonRefresh}
                            searchData={searchData}
                            getDataDoctorName={getDataDoctorName}
                            showCustomButtonRelationPatient={false}
                        />
                        {/* end` header */}

                        <Col xl='12' sm='12'>
                            <div>
                                {/* start table */}
                                <TableAppointmentDoctor
                                    getData={getData}
                                    modalDetailPatient={modalDetailPatient}
                                    rows={rows}
                                    page={page}
                                    pages={pages}
                                    level={level}
                                    changePage={changePage}
                                    msg={msg}
                                    isTabletOrMobile={false}
                                />
                                {/* end table */}
                            </div>
                        </Col>
                    </>
                    :
                    <>
                        {/* start header */}
                        <HeaderApointmentDoctor
                            isTabletOrMobile={isTabletOrMobile}
                            query={query}
                            countAppointment={countAppointment}
                            setQuery={setQuery}
                            limit={limit}
                            setLimit={setLimit}
                            setPage={setPage}
                            buttonRefresh={buttonRefresh}
                            searchData={searchData}
                            handleReset={handleReset}
                            getDataDoctorName={getDataDoctorName}
                            showCustomButtonRelationPatient={false}
                        />
                        {/* end` header */}

                        <Col xl='12' sm='12'>
                            <div>
                                {/* start table */}
                                <TableAppointmentDoctor
                                    getData={getData}
                                    modalDetailPatient={modalDetailPatient}
                                    rows={rows}
                                    page={page}
                                    pages={pages}
                                    msg={msg}
                                    level={level}
                                    changePage={changePage}
                                    isTabletOrMobile={false}

                                />
                                {/* end table */}
                            </div>
                        </Col>
                    </>
                }
            </div>
        </>
    );
}
